import classNames from 'classnames'
import { FieldError } from 'react-hook-form'

import { isEmailInput, normalizeEmailInputValue } from './emailInput'

interface IProps {
  id: string
  containerClassName?: string
  className?: string
  type: string
  label: string
  placeholder: string
  showLabel?: boolean
  errors?: FieldError
  hideErrors?: boolean
  value: any
  onChange: (e: any) => void
}

export const ControlledInputSm = (props: IProps) => {
  const {
    id,
    containerClassName,
    className,
    type = 'text',
    showLabel = false,
    errors,
    label,
    placeholder,
    hideErrors = false,
    value,
    onChange
  } = props
  const shouldNormalizeEmail = isEmailInput({ type, id, label })
  const handleChange = (e: any) => {
    e.target.value = normalizeEmailInputValue(e.target.value, shouldNormalizeEmail)
    onChange(e)
  }

  return (
    <div className={classNames('mb-4', containerClassName)}>
      <label className={classNames('block pl-2 pb-2 text-md text-text-muted font-bold', { 'sr-only': !showLabel })} htmlFor={id}>
        {label}
      </label>
      <div className='relative'>
        <input
          id={id}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          autoCapitalize={shouldNormalizeEmail ? 'none' : undefined}
          spellCheck={shouldNormalizeEmail ? false : undefined}
          className={classNames(
            'input-bordered border-border disabled:border-border/50 bg-surface disabled:bg-surface-2 placeholder:text-text-muted/70 text-text input w-full text-sm max-h-[35px] h-[35px] sm:max-h-[40px] sm:h-[40px] rounded-[20px] focus:outline-none',
            { 'input-error': errors },
            className
          )}
        />
        {!hideErrors && (
          <p className={classNames('pl-2 pt-2 text-[11px]', !errors?.message && 'text-text-muted', errors?.message && 'text-errors')}>
            {errors?.message}
          </p>
        )}
      </div>
    </div>
  )
}
